import { SparkleEffect } from "./SparkleEffect";
import { Heart } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="relative mt-20 py-8 border-t border-border/50 bg-card/50 backdrop-blur-sm">
      <SparkleEffect />
      
      <div className="container mx-auto px-4">
        <div className="flex flex-col items-center space-y-4 relative z-10">
          <p className="text-sm text-muted-foreground flex items-center gap-2">
            Made with <Heart className="h-4 w-4 text-accent fill-accent" /> for wishmakers everywhere
          </p>
          <p className="text-xs text-muted-foreground">
            © 2025 Encrypted Wish Draw. All wishes are encrypted.
          </p>
        </div>
      </div>
    </footer>
  );
};
